module.exports = __webpack_public_path__ + "static/divider15-95a5bf5b5b0f2c66c8e342c59b5337eb.svg";